/**
 * resusable component to create and edit resource links
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// import actions
import * as moduleCertificateActions from '../moduleCertificateActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import Modal from '../../../global/components/modals/Modal.js.jsx';

// import third-party libraries
import _ from 'lodash';
import { DateTime } from 'luxon';

import {
  RadioInput
  , SelectFromArray
  , SelectFromObject
  , SingleDatePickerInput
} from '../../../global/components/forms';

import moduleCertificatetyles from '../moduleCertificateModuleStyles.css';

class EditCertModal extends Base {
  constructor(props) {
    super(props);
    this.state = {
      newModuleCertificate: _.cloneDeep(this.props.moduleCertificate)
      , formHelpers: {
        issuedDate: this.props.moduleCertificate.issuedDate ? DateTime.fromISO(this.props.moduleCertificate.issuedDate).valueOf() : DateTime.local().valueOf()
        , doesExpire: this.props.moduleCertificate.expires ? 'yes' : 'no'
        , expires: this.props.moduleCertificate.expires ? DateTime.fromISO(this.props.moduleCertificate.expires).valueOf() : DateTime.local().plus({years: 2}).valueOf()
        , statuses: [
          'completed'
          , 'expiring-soon'
          , 'expired'
          , 'revoked'
          , 'exempt'
          , 'invalidated'
          , 'excluded'
          , 'pending-attestation']
      }
    }
    this._bind(
      '_cancelChanges'
      , '_handleFormChange'
      , '_handleSave'
    )
  }

  _cancelChanges() {
    this.setState({
      newModuleCertificate: _.cloneDeep(this.props.moduleCertificate)
    })
    this.props.closeModal()
  }

  _handleFormChange(e) {
    let newState = _.update( this.state, e.target.name, function() {
      return e.target.value;
    });
    this.setState(newState);
  }

  _handleSave() {
    const { closeModal, dispatch, formType, loggedInUser, selectedUserId } = this.props;
    // let newCert = {...this.state.newModuleCertificate};
    let newCert = _.cloneDeep(this.state.newModuleCertificate);
    const formHelpers = {...this.state.formHelpers};
    // console.log(formHelpers);
    newCert.issuedDate = new Date(formHelpers.issuedDate);
    if(formHelpers.doesExpire === 'yes') {
      newCert.expires = new Date(formHelpers.expires);
    } else {
      newCert.expires = null;
    }
    if(formType === 'Create') {
      newCert._user = selectedUserId;
      newCert._adminCreator = loggedInUser._id;
      newCert._lastModifiedBy = loggedInUser._id;
      dispatch(moduleCertificateActions.sendCreateModuleCertificate(newCert)).then(action => {
        if(action.success) {
          // console.log('success');
          dispatch(moduleCertificateActions.invalidateList('_user', selectedUserId));
          closeModal()
        } else {
          alert(`ERROR: ${action.error}`);
        }
      })
    } else {
      newCert._lastModifiedBy = loggedInUser._id;
      dispatch(moduleCertificateActions.sendUpdateModuleCertificate(newCert)).then(action => {
        if(action.success) {
          console.log('success');
          dispatch(moduleCertificateActions.invalidateList('_user', selectedUserId));
          closeModal()
        } else {
          alert(`ERROR: ${action.error}`);
        }
      })
    }
  }

  render() {
    const { formType, isOpen, moduleCertificate, contentModules } = this.props;
    const { formHelpers, newModuleCertificate } = this.state;
    return (
      <Modal
        cardSize='standard'
        closeAction={this._cancelChanges}
        closeText="Cancel changes"
        confirmAction={this._handleSave}
        confirmText="Save"
        disableConfirm={!this.state.newModuleCertificate._contentModule || !this.state.newModuleCertificate.status}
        isOpen={isOpen}
        modalHeader={`${formType} content module certificate`}
        showButtons={true}
      >
        <div styleName="-module-cert-form">
          <h3>Certificate of Completion</h3>
          <div className="yt-col full s_60">
            <SelectFromObject
              change={this._handleFormChange}
              clearable={true}
              disabled={formType === 'Update'}
              display={'title'}
              filterable={true}
              label="Module"
              name="newModuleCertificate._contentModule"
              objects={contentModules}
              placeholder="-- Select a Module --"
              required={true}
              selected={newModuleCertificate._contentModule}
              value={'_id'}
            />
            <SelectFromArray
              change={this._handleFormChange}
              items={formHelpers.statuses}
              label={"Status"}
              name="newModuleCertificate.status"
              required={true}
              value={newModuleCertificate.status}
            />
            <span>NOTE: NEVER manually set the following statuses: Excluded, Invalidated, Pending-Attestation</span>
            <br/>
            <SingleDatePickerInput
              change={this._handleFormChange}
              label="Completed Date"
              initialDate={formHelpers.issuedDate}
              name='formHelpers.issuedDate'
              numberOfMonths={1}
            />
            <RadioInput
              label="Does this certificate expire?"
              options={[
                {val: 'yes', display: 'Yes'},
                {val: 'no', display: 'No'},
              ]}
              name="formHelpers.doesExpire"
              value={formHelpers.doesExpire}
              change={this._handleFormChange}
              inLine={true}
            />
            { formHelpers.doesExpire === 'yes' ?
              <SingleDatePickerInput
                change={this._handleFormChange}
                label="Expiriation Date"
                initialDate={formHelpers.expires}
                name='formHelpers.expires'
                numberOfMonths={1}
              />
            :
            null
            }
          </div>
        </div>
      </Modal>
    )
  }
}

EditCertModal.propTypes = {
  closeModal: PropTypes.func.isRequired
  , dispatch: PropTypes.func.isRequired
  , formType: PropTypes.string
  , isOpen: PropTypes.bool
  , selectedUserId: PropTypes.string.isRequired
  , contentModules: PropTypes.array
  , moduleCertificate: PropTypes.object.isRequired
}

EditCertModal.defaultProps = {
  formType: 'Create'
  , isOpen: false
  , contentModules: []
}



const mapStoreToProps = (store) => {
  return {
    loggedInUser: store.user.loggedIn.user
  }
}

export default connect(
  mapStoreToProps
)(EditCertModal);



// WEBPACK FOOTER //
// modules/moduleCertificate/components/EditCertModal.js.jsx